const TRANSLATIONS = {
	pt: {
		title: "Nao foi possivel carregar o Flowch Talk",
		description:
			"Atualize a pagina para carregar a versao mais recente. Se o problema continuar, acione o suporte.",
		transient:
			"A conexao oscilou durante o carregamento. Estamos tentando recuperar a tela automaticamente.",
		refresh: "Atualizar pagina",
		details: "Detalhes tecnicos",
		copy: "Copiar detalhes",
		copied: "Detalhes copiados"
	},
	en: {
		title: "Flowch Talk could not be loaded",
		description:
			"Refresh the page to load the latest version. If the problem continues, contact support.",
		transient:
			"The connection changed while loading. We are trying to recover the screen automatically.",
		refresh: "Refresh page",
		details: "Technical details",
		copy: "Copy details",
		copied: "Details copied"
	},
	es: {
		title: "No fue posible cargar Flowch Talk",
		description:
			"Actualice la pagina para cargar la version mas reciente. Si el problema continua, contacte a soporte.",
		transient:
			"La conexion cambio durante la carga. Estamos intentando recuperar la pantalla automaticamente.",
		refresh: "Actualizar pagina",
		details: "Detalles tecnicos",
		copy: "Copiar detalles",
		copied: "Detalles copiados"
	}
};

const getLanguage = () => {
	try {
		const storedLanguage = String(localStorage.getItem("i18nextLng") || "");
		if (storedLanguage.toLowerCase().startsWith("en")) return "en";
		if (storedLanguage.toLowerCase().startsWith("es")) return "es";
	} catch (_err) {
		// Ignore storage restrictions.
	}

	const browserLanguage = String(navigator?.language || "").toLowerCase();
	if (browserLanguage.startsWith("en")) return "en";
	if (browserLanguage.startsWith("es")) return "es";

	return "pt";
};

export const getApplicationErrorCopy = () => TRANSLATIONS[getLanguage()] || TRANSLATIONS.pt;

export const getErrorText = error =>
	String(error?.stack || error?.message || error || "Unknown error");

export const isDomMutationError = error => {
	const text = getErrorText(error);
	return (
		text.includes("removeChild") ||
		text.includes("insertBefore") ||
		text.includes("Node.removeChild") ||
		text.includes("The node to be removed is not a child of this node") ||
		text.includes("O no a ser removido nao e filho deste no") ||
		text.includes("O no a ser removido nao e filho deste no") ||
		text.includes("O nó a ser removido não é filho deste nó")
	);
};

export const isTransientLoadError = error => {
	const text = getErrorText(error).toLowerCase();
	return (
		text.includes("network error") ||
		text.includes("failed to fetch") ||
		text.includes("load failed") ||
		text.includes("loading chunk") ||
		text.includes("dynamically imported module") ||
		text.includes("importing a module script failed") ||
		text.includes("socket") ||
		text.includes("websocket")
	);
};

export const reloadOnce = (key, delay = 0) => {
	try {
		if (sessionStorage.getItem(key) === "1") {
			return false;
		}
		sessionStorage.setItem(key, "1");
	} catch (_err) {
		return false;
	}

	window.setTimeout(() => window.location.reload(), delay);
	return true;
};

export const renderApplicationErrorHtml = ({
	errorText,
	transient = false
}) => {
	const copy = getApplicationErrorCopy();
	const safeErrorText = String(errorText || "Unknown error")
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;");

	return `
		<div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #f3f4f6; font-family: Arial, sans-serif; color: #1f2937; padding: 24px;">
			<div style="width: min(560px, 100%); background: #ffffff; border: 1px solid #e5e7eb; border-radius: 8px; box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12); padding: 28px;">
				<div style="width: 44px; height: 44px; border-radius: 12px; background: #ede9fe; color: #6e2ad3; display: flex; align-items: center; justify-content: center; font-size: 24px; margin-bottom: 18px;">!</div>
				<h1 style="font-size: 22px; line-height: 1.25; margin: 0 0 10px;">${copy.title}</h1>
				<p style="font-size: 15px; line-height: 1.55; color: #4b5563; margin: 0 0 18px;">${transient ? copy.transient : copy.description}</p>
				<button onclick="window.location.reload()" style="height: 42px; border: 0; border-radius: 6px; background: #6e2ad3; color: #ffffff; font-weight: 700; padding: 0 18px; cursor: pointer;">${copy.refresh}</button>
				<details style="margin-top: 20px;">
					<summary style="cursor: pointer; color: #6e2ad3; font-weight: 700;">${copy.details}</summary>
					<pre id="flowch-error-details" style="white-space: pre-wrap; max-height: 220px; overflow: auto; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 6px; padding: 12px; color: #374151;">${safeErrorText}</pre>
					<button onclick="navigator.clipboard && navigator.clipboard.writeText(document.getElementById('flowch-error-details').innerText).then(function(){ this.innerText='${copy.copied}' }.bind(this))" style="height: 34px; border: 1px solid #d1d5db; border-radius: 6px; background: #ffffff; color: #374151; font-weight: 700; padding: 0 12px; cursor: pointer;">${copy.copy}</button>
				</details>
			</div>
		</div>
	`;
};
